import React from 'react';
import styled from 'styled-components';
import { ICON_CLOSE, ICON_SETTLEMENT_ARROW_RIGHT } from 'assets/icons';
import { FilterType } from '../hooks/useSettlementDetailHooks';
import ModalContainer from 'containers/ProductRegist/components/common/ModalContainer';
import Column from 'components/common/Column';
import CommonImage from 'components/common/CommonImage';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  width: 100%;

  color: #1b1c1e;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.16px;
`;

interface SettlementFilterModalIProps {
  isMobile: boolean;
  handleAccountListFilter: (filterType: FilterType) => void;
  onClose: () => void;
}

const SettlementFilterModal: React.FC<SettlementFilterModalIProps> = props => {
  const { isMobile, handleAccountListFilter, onClose } = props;

  return (
    <ModalContainer
      isMobile={isMobile}
      isAbled={true}
      isBottomSheet={true}
      onClick={() => {}}
      onClose={onClose}
    >
      <Column gap="20px" align="flex-start" style={{ padding: '20px' }}>
        <CommonImage src={ICON_CLOSE} onClick={onClose} />
        <Column>
          <Row
            onClick={() => {
              handleAccountListFilter(FilterType.DATE);
              onClose();
            }}
          >
            <span>결제일순</span>
            <img src={ICON_SETTLEMENT_ARROW_RIGHT} alt="arrow right icon" />
          </Row>
          <Row
            onClick={() => {
              handleAccountListFilter(FilterType.TYPE);
              onClose();
            }}
          >
            <span>유형별</span>
            <img src={ICON_SETTLEMENT_ARROW_RIGHT} alt="arrow right icon" />
          </Row>
          <Row
            onClick={() => {
              handleAccountListFilter(FilterType.PRODUCT);
              onClose();
            }}
          >
            <span>상품별</span>
            <img src={ICON_SETTLEMENT_ARROW_RIGHT} alt="arrow right icon" />
          </Row>
        </Column>
      </Column>
    </ModalContainer>
  );
};

export default SettlementFilterModal;
